import thoth from '../api/thoth';
import BaseFetch from './base';

export default class Thoth extends BaseFetch {
    api = thoth
}
